import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function HeroSection() {
  return <section className="w-full bg-cream flex flex-col items-center" data-id="element-51">
      {/* Urgency Banner */}
      <div className="w-full bg-gradient-to-r from-gold-400 to-gold-500 text-white text-center py-2 px-4 font-bold text-sm md:text-base tracking-wide shadow-sm" data-id="element-52">
        ⏳ OFERTA POR TIEMPO LIMITADO 🔥 ACCESO DISPONIBLE HOY
      </div>

      <div className="max-w-4xl w-full px-4 pt-10 pb-16 flex flex-col items-center text-center" data-id="element-53">
        <p className="text-brown-600 font-semibold mb-4 max-w-2xl text-sm md:text-base uppercase tracking-wider" data-id="element-54">
          📐 Para mujeres con poco tiempo que quieren cocinar menos, gastar
          menos y dejar de improvisar comidas todos los días
        </p>

        <h1 className="text-4xl md:text-6xl font-extrabold text-brown-800 mb-4 leading-tight" data-id="element-55">
          FREEZER INTELIGENTE
        </h1>

        <img src="https://cdn.magicpatterns.com/uploads/5gFsyAXkGVtGme5x6jDee5/hf_20260322_221809_79e8e486-2662-4996-bd6d-7d3c16bd5e21.jpg" alt="Colección Freezer Inteligente" className="w-full max-w-2xl rounded-xl shadow-2xl mb-8 border-4 border-white object-cover" width="664" height="498" loading="eager" fetchPriority="high" decoding="async" data-id="element-56" />

        <h2 className="text-xl md:text-2xl font-bold text-brown-800 mb-4 max-w-2xl" data-id="element-57">
          La colección digital para comer 30 días con poco tiempo y menos gasto
        </h2>

        <p className="text-lg text-brown-600 mb-8 max-w-2xl" data-id="element-58">
          Todo lo que necesitás para organizar tus comidas, resolver viandas y
          usar mejor tu freezer sin vivir metida en la cocina.
        </p>

        <a href="#compra" className="bg-gradient-to-r from-gold-400 to-gold-500 text-white font-bold text-lg md:text-xl py-4 px-8 rounded-full shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 w-full max-w-md text-center" data-id="element-59">
          👉 SÍ, QUIERO ACCEDER AHORA
        </a>

        <div className="flex items-center gap-2 mt-4 text-brown-600 font-semibold text-sm" data-id="element-60">
          <ShieldCheck className="text-green-600" size={18} data-id="element-61" />
          <span data-id="element-62">✅ Garantía de satisfacción de 7 días</span>
        </div>
      </div>
    </section>;
}